import { COMPANY_MODAL_KEYS, COMPANY_MODAL_TITLES } from "../../../../utils/enum";
import { formatMillisecondsTohours } from "../../../../Utils";
import { formatUTCDate, formatUTCDateShort } from "@demandproai/shared";
import { COMPANY_STATUS } from '@demandproai/shared';
import XButton from '../../../../components/common/XButton';

import RunningCaseBlackIcon from '../../../../assets/icons/RunningCaseBlackIcon.svg?react';
import LimboCaseBlackIcon from '../../../../assets/icons/LimboCaseBlackIcon.svg?react';
import PercentileBlackIcon from '../../../../assets/icons/PercentileBlackIcon.svg?react';
import SdCardAlertIcon from '../../../../assets/icons/SdCardAlertIcon.svg?react';
import FailedCaseIcon from '../../../../assets/icons/FailedCaseIcon.svg?react';
import FailedCasesWhiteIcon from '../../../../assets/icons/FailedCasesWhiteIcon.svg?react';
import SuccessfullCaseIcon from '../../../../assets/icons/SuccessfullCaseIcon.svg?react';
import RunningCasesIcon from '../../../../assets/icons/RunningCasesIcon.svg?react';
import LimboCaseIcon from '../../../../assets/icons/LimboCaseIcon.svg?react';
import PercentileIcon from '../../../../assets/icons/PercentileIcon.svg?react';
import StatUserIcon from '../../../../assets/icons/StatUserIcon.svg?react';
import WhiteALaCarteIcon from '../../../../assets/icons/WhiteALaCarteIcon.svg?react';
import InactiveAccountIcon from '../../../../assets/icons/InactiveAccountIcon.svg?react';
import MmrWhitIcon from '../../../../assets/icons/MmrWhitIcon.svg?react';
import AnnualTargetWhiteIcon from '../../../../assets/icons/AnnualTargetWhiteIcon.svg?react';
import PercentYtdIcon from '../../../../assets/icons/PercentYtdIcon.svg?react';
import ChatIconWhite from '../../../../assets/icons/ChatIconWhite.svg?react';
import MedicalCronologyIcon from '../../../../assets/icons/MedicalCronologyIcon.svg?react';


export const companyModalConfig = {

  [COMPANY_MODAL_KEYS.ACTIVE]: {
    title: COMPANY_MODAL_TITLES.ACTIVE,
    emptyMessage: "No active companies found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Total Cases", dataKey: "totalCases" }
    ],
    getCompanies: ({ activeCompanies }) => activeCompanies,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.CASE_VOLUME]: {
    title: COMPANY_MODAL_TITLES.CASE_VOLUME,
    emptyMessage: "No cases found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Total Cases", dataKey: "totalCases" }
    ],
    getCompanies: ({ activeCompanies }) => activeCompanies,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.INACTIVE]: {
    title: COMPANY_MODAL_TITLES.INACTIVE,
    emptyMessage: "No inactive companies found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Tier", dataKey: "tier" },
      {
        header: "Subscription Start Date",
        render: (row) => formatUTCDate(row.startedOn)
      },
      {
        header: "Last Demand Created",
        render: (row) =>
          row.lastDemandCreatedDate
            ? formatUTCDate(row.lastDemandCreatedDate)
            : "-"
      },
      { header: "Total Demands", dataKey: "totalDemands" },
      { header: "Days Since Last Activity", dataKey: "daysSinceLastActivity" }
    ],
    getCompanies: ({ inactiveCompanies }) => inactiveCompanies,
    histogramColumnIndex: 4
  },

  [COMPANY_MODAL_KEYS.CREDIT]: {
    title: COMPANY_MODAL_TITLES.CREDIT,
    emptyMessage: "No credit data found for selected companies",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Total Credit Charged", dataKey: "totalCreditsCharged" }
    ],
    getCompanies: ({ creditedCompanies }) => creditedCompanies,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.CHAT_SESSIONS]: {
    title: COMPANY_MODAL_TITLES.CHAT_SESSIONS,
    emptyMessage: "No chat sessions found for selected companies",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Total Chat Sessions", dataKey: "chatSessions" }
    ],
    getCompanies: ({ companyChatSessions }) => companyChatSessions,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.ICD_DISABLED_CASES]: {
    title: COMPANY_MODAL_TITLES.ICD_DISABLED_CASES,
    emptyMessage: "No cases with ICD codes disabled found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Disabled Cases", dataKey: "count" }
    ],
    getCompanies: ({ icdDisabledByCompany }) => icdDisabledByCompany || [],
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.COST]: {
    title: COMPANY_MODAL_TITLES.COST,
    emptyMessage: "No cost data found for selected companies",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      {
        header: "Total Cost",
        render: (row) => `$${Number(row.totalCostPerCompany.toFixed(2))}`
      },
      { header: "Total Credit Charged", dataKey: "totalCreditCharged" }
    ],
    getCompanies: ({ companiesCostData }) => companiesCostData,
    histogramColumnIndex: 2
  },

  [COMPANY_MODAL_KEYS.RENEWAL_COMPANIES]: {
    title: COMPANY_MODAL_TITLES.RENEWAL_COMPANIES,
    emptyMessage: "No companies available",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Tier", dataKey: "tier" },
      {
        header: "Renewal Date",
        render: (row) => formatUTCDateShort(row.renewalDate)
      },
      { header: "Days Left", dataKey: "remainingDays" }
    ],
    getCompanies: ({ companiesData }) => companiesData,
    histogramColumnIndex: 3
  },

  [COMPANY_MODAL_KEYS.FAILED_CASES]: {
    title: COMPANY_MODAL_TITLES.FAILED_CASES,
    emptyMessage: "No failed cases found",
    columns: [
      { header: "Company", dataKey: "database" },
      { header: "Case ID", dataKey: "caseId" }
    ],
    getCompanies: ({ failedCasesTableData }) => failedCasesTableData || []
  },

  [COMPANY_MODAL_KEYS.PREVIOUS_FAILED_CASES]: {
    title: COMPANY_MODAL_TITLES.PREVIOUS_FAILED_CASES,
    emptyMessage: "No previously failed cases found",
    columns: [
      { header: "Company", dataKey: "database" },
      { header: "Case ID", dataKey: "caseId" }
    ],
    getCompanies: ({ previouslyFailedTableData }) => previouslyFailedTableData
  },

  [COMPANY_MODAL_KEYS.RUNNING_CASES]: {
    title: COMPANY_MODAL_TITLES.RUNNING_CASES,
    emptyMessage: "No running cases found",
    columns: [
      { header: "Company", dataKey: "dbName" },
      { header: "Case Id", dataKey: "caseId" },
      { header: "Running Job Id", dataKey: "runningJobId" },
      { header: "Running For", dataKey: "runningFor" }
    ],
    getCompanies: ({ runningCasesTableData }) => runningCasesTableData,
    histogramColumnIndex: 2
  },

  [COMPANY_MODAL_KEYS.SUCCESSFUL_CASES]: {
    title: COMPANY_MODAL_TITLES.SUCCESSFUL_CASES,
    emptyMessage: "No successful cases found",
    columns: [
      { header: "Company", dataKey: "database" },
      { header: "Successful Cases", dataKey: "successfulCases" }
    ],
    getCompanies: ({ successfulCasesData }) => successfulCasesData,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.NON_SUCCESSFUL_CASES]: {
    title: COMPANY_MODAL_TITLES.NON_SUCCESSFUL_CASES,
    emptyMessage: "No non successful cases found",
    columns: [
      { header: "Company", dataKey: "database" },
      { header: "Non Successful", dataKey: "nonSuccessfulCount" },
    ],
    getCompanies: ({ nonSuccessfulCasesTableData }) => nonSuccessfulCasesTableData,
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.UNFULFILLED_RUNNING_CASES]: {
    title: COMPANY_MODAL_TITLES.UNFULFILLED_RUNNING_CASES,
    emptyMessage: "No unfulfilled running cases found",
    columns: [
      { header: "Company", dataKey: "dbName" },
      { header: "Case Id", dataKey: "caseId" },
      { header: "Demand Letter Progress", dataKey: "demandLetterProgress" },
      { header: "Running For", dataKey: "runningForSeconds" }
    ],
    getCompanies: ({ unfulfilledRunningCases }) => unfulfilledRunningCases
  },

  [COMPANY_MODAL_KEYS.LIMBO_CASES]: {
    title: COMPANY_MODAL_TITLES.LIMBO_CASES,
    emptyMessage: "No limbo cases found",
    columns: [
      { header: "Company", dataKey: "database" },
      { header: "Case ID", dataKey: "caseId" }
    ],
    getCompanies: ({ limboCasesTableData }) => limboCasesTableData
  },

  [COMPANY_MODAL_KEYS.PERCENTILE_CASES]: {
    title: COMPANY_MODAL_TITLES.PERCENTILE_CASES,
    emptyMessage: "No 99 percentile cases found",
    columns: [
      { header: "Company", dataKey: "dbName" },
      { header: "Case ID", dataKey: "caseId" }
    ],
    getCompanies: ({ p99Cases }) => p99Cases
  },

  [COMPANY_MODAL_KEYS.ROLLOVER_CREDITS]: {
    title: COMPANY_MODAL_TITLES.ROLLOVER_CREDITS,
    emptyMessage: "No rollover credits found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "Rollover Credits", dataKey: "value" }
    ],
    getCompanies: ({ rollOverCreditAnalytics }) => rollOverCreditAnalytics || [],
    histogramColumnIndex: 1
  },

  [COMPANY_MODAL_KEYS.ALACARTE_CREDITS]: {
    title: COMPANY_MODAL_TITLES.ALACARTE_CREDITS,
    emptyMessage: "No à la carte credits found",
    columns: [
      { header: "Company Name", dataKey: "companyName" },
      { header: "À La Carte Credits", dataKey: "value" }
    ],
    getCompanies: ({ alaCarteCreditAnalytics }) => alaCarteCreditAnalytics || [],
    histogramColumnIndex: 1
  },

  [COMPANY_STATUS.SUBSCRIBED]: {
    title: COMPANY_MODAL_TITLES.SIGNED_UP,
    columns: [
      { header: "Company", dataKey: "companyName" },
      {
        header: "Started On",
        render: (row) =>
          row.startedOn ? formatUTCDate(row.startedOn) : "-"
      }
    ],
    getCompanies: ({ companiesYTDData }) => companiesYTDData?.SUBSCRIBED || []
  },

  [COMPANY_STATUS.CANCELED]: {
    title: COMPANY_MODAL_TITLES.CANCELED,
    columns: [
      { header: "Company", dataKey: "companyName" },
      {
        header: "Started On",
        render: (row) =>
          row.startedOn ? formatUTCDate(row.startedOn) : "-"
      },
      {header:'Updated On', render: (row) =>
          row.lastStatusUpdatedOn ? formatUTCDate(row.lastStatusUpdatedOn) : "-"}
    ],
    getCompanies: ({ companiesYTDData }) => companiesYTDData?.CANCELED || []
  }

};

export const createDashboardTableSections = ({
  isTokenInput,
  setIsTokenInput,
  onOpenHistogramModal,
  onOpenContentDistribution
}) => [
    [
      {
        title: "Failed Cases",
        icon: <FailedCaseIcon />,
        columns: [
          { header: "Company", dataKey: "database" },
          { header: "Case ID", dataKey: "caseId" }
        ],
        dataKey: "failedCasesTableData"
      },
      {
        title: "Failed Records",
        icon: <SdCardAlertIcon />,
        columns: [
          { header: "Company", dataKey: "database" },
          { header: "Record ID", dataKey: "recordId" }
        ],
        dataKey: "failedRecordsTableData"
      }
    ],

    [
      {
        title: "Currently Running Cases",
        icon: <RunningCaseBlackIcon />,
        columns: [
          { header: "Case Id", dataKey: "caseId" },
          { header: "Running Job Id", dataKey: "runningJobId" },
          { header: "Running For", dataKey: "runningFor" }
        ],
        dataKey: "runningCasesTableData"
      },
      {
        title: "Processing Time of Top 1% of 99 percentile",
        icon: <PercentileBlackIcon />,
        columns: [
          { header: "Company", dataKey: "dbName" },
          { header: "Case ID", dataKey: "caseId" }
        ],
        dataKey: "p99Cases"
      }
    ],

    [
      {
        title: "Limbo Cases",
        icon: <LimboCaseBlackIcon />,
        columns: [
          { header: "Company", dataKey: "database" },
          { header: "Case ID", dataKey: "caseId" }
        ],
        dataKey: "limboCasesTableData",
      },

      {
        title: "Non Successful Cases",
        icon: <FailedCaseIcon />,
        columns: [
          { header: "Company", dataKey: "database" },
          { header: "Failed Cases", dataKey: "caseId" }
        ],
        dataKey: "nonSuccessfulCasesTableData"
      }
    ],

    [
      {
        title: "Unfulfilled Running Cases",
        icon: <RunningCaseBlackIcon />,
        columns: [
          { header: "Company", dataKey: "dbName" },
          { header: "Case Id", dataKey: "caseId" },
          { header: "Demand Letter Progress", dataKey: "demandLetterProgress" },
          { header: "Running For", dataKey: "runningForSeconds" }
        ],
        dataKey: "unfulfilledRunningCases"
      },

      {
        title: "Prompts",
        icon: <LimboCaseBlackIcon />,
        columns: [
          { header: "Prompt ID", dataKey: "promptId" },
          { header: "Median", dataKey: "median" },
          { header: "Prompt Count", dataKey: "promptCount" }
        ],
        dataKey: "promptId",

        headerExtra: (
          <div className="flex items-center gap-4">
            <XButton
              variant="outline"
              onClick={() => setIsTokenInput(!isTokenInput)}
            >
              {isTokenInput ? "Output Token" : "Input Token"}
            </XButton>
          </div>
        ),

        onRowClick: (row) => onOpenHistogramModal(row.promptId)
      }
    ],
    [
      {
        title: "Case Page Distribution",
        icon: <PercentileBlackIcon />,
        columns: [
          { header: "Company", dataKey: "companyName" },
          { header: "Median Pages", dataKey: "median" },
          { header: "Total Cases", dataKey: "totalCases" }
        ],
        dataKey: "casePageDistribution",
        onRowClick: (row) => onOpenContentDistribution({ row, metricLabel: "Total Pages" })
      },
      {
        title: "Treatment Date Count Distribution",
        icon: <PercentileBlackIcon />,
        columns: [
          { header: "Company", dataKey: "companyName" },
          { header: "Median Treatment Dates", dataKey: "median" },
          { header: "Total Cases", dataKey: "totalCases" }
        ],
        dataKey: "treatmentDateCountDistribution",
        onRowClick: (row) => onOpenContentDistribution({ row, metricLabel: "Treatment Dates" })
      }
    ],
    [
      {
        title: "Treatment Dates Text Length Distribution",
        icon: <PercentileBlackIcon />,
        columns: [
          { header: "Company", dataKey: "companyName" },
          { header: "Median Text Length", dataKey: "median" },
          { header: "Total Cases", dataKey: "totalCases" }
        ],
        dataKey: "treatmentDateTextLengthDistribution",
        onRowClick: (row) => onOpenContentDistribution({ row, metricLabel: "Treatment Dates Text Length" })
      },
      {
        title: "Lifecare Plan Length Distribution",
        icon: <PercentileBlackIcon />,
        columns: [
          { header: "Company", dataKey: "companyName" },
          { header: "Median Lifecare Plan Length", dataKey: "median" },
          { header: "Total Cases", dataKey: "totalCases" }
        ],
        dataKey: "lifecarePlanLengthDistribution",
        onRowClick: (row) => onOpenContentDistribution({ row, metricLabel: "Lifecare Plan Length" })
      }
    ]
  ];

export const renderAnalyticsStatCards = ({
  previouslyFailed,
  successfulCasesData,
  totalNonSuccessfulCases,
  runningCases,
  unfulfilledRunningCases,
  limboCases,
  p99Cases,
  totalChatSessions,
  isChatSessionsLoading,
  totalIcdDisabled,
  isIcdDisabledLoading,
  isLoading
}) => [
    {
      title: "Previously Failed Cases",
      icon: <FailedCasesWhiteIcon />,
      value: previouslyFailed?.totalRecovered,
      modal: COMPANY_MODAL_KEYS.PREVIOUS_FAILED_CASES,
      isLoading
    },
    {
      title: "Successful cases",
      icon: <SuccessfullCaseIcon />,
      value: successfulCasesData?.totalSuccessful,
      modal: COMPANY_MODAL_KEYS.SUCCESSFUL_CASES,
      isLoading
    },
    {
      title: "Non Successful Cases",
      icon: <FailedCasesWhiteIcon />,
      value: totalNonSuccessfulCases,
      modal: COMPANY_MODAL_KEYS.FAILED_CASES,
      isLoading: isLoading
    },
    {
      title: "Running cases",
      icon: <RunningCasesIcon />,
      value: runningCases?.data?.size,
      modal: COMPANY_MODAL_KEYS.RUNNING_CASES,
      isLoading
    },
    {
      title: "Unfulfilled Running cases",
      icon: <RunningCasesIcon />,
      value: unfulfilledRunningCases?.data?.size,
      modal: COMPANY_MODAL_KEYS.UNFULFILLED_RUNNING_CASES,
      isLoading
    },
    {
      title: "Limbo cases",
      icon: <LimboCaseIcon />,
      value: limboCases?.totalCases,
      modal: COMPANY_MODAL_KEYS.LIMBO_CASES,
      isLoading
    },
    {
      title: "99 Percentile",
      icon: <PercentileIcon />,
      value: formatMillisecondsTohours(p99Cases?.data?.lowestProcessTime),
      modal: COMPANY_MODAL_KEYS.PERCENTILE_CASES,
      isLoading
    },
    {
      title: "Chat Sessions",
      icon: <ChatIconWhite />,
      value: totalChatSessions,
      modal: COMPANY_MODAL_KEYS.CHAT_SESSIONS,
      isLoading: isChatSessionsLoading
    },
    {
      title: "ICD Code Disabled Cases",
      icon: <MedicalCronologyIcon />,
      value: totalIcdDisabled,
      modal: COMPANY_MODAL_KEYS.ICD_DISABLED_CASES,
      isLoading: isIcdDisabledLoading
    }
  ];

export const renderSuperDashboardStatCards = ({
  activeCompanies,
  inactiveCompanies,
  totalCreditCount,
  totalFailedCases,
  isLoading,
  isCreditLoading,
  isFailedCasesLoading
}) => [
    {
      title: "Active",
      icon: <StatUserIcon />,
      value: activeCompanies?.length || 0,
      modal: COMPANY_MODAL_KEYS.ACTIVE,
      isLoading
    },
    {
      title: "Total credits used",
      icon: <WhiteALaCarteIcon />,
      value: totalCreditCount,
      modal: COMPANY_MODAL_KEYS.CREDIT,
      isLoading: isCreditLoading
    },
    {
      title: "Failed Cases",
      icon: <FailedCasesWhiteIcon />,
      value: totalFailedCases,
      modal: COMPANY_MODAL_KEYS.FAILED_CASES,
      isLoading: isFailedCasesLoading
    },
    {
      title: "Inactive Accounts",
      icon: <InactiveAccountIcon />,
      value: inactiveCompanies?.length || 0,
      modal: COMPANY_MODAL_KEYS.INACTIVE,
      isLoading
    }
  ];

export const renderCompanySalesStatCards = ({
  totalSignups,
  totalRevenue,
  totalAnnualTarget,
  currencyFormatter,
  ytdCommission
}) => [
    {
      title: "Total Signups YTD",
      icon: <StatUserIcon />,
      value: totalSignups,
      loadingKey: "signup"
    },
    {
      title: "Current MRR",
      icon: <MmrWhitIcon />,
      value: `$${currencyFormatter(totalRevenue)}`,
      loadingKey: "revenue"
    },
    {
      title: "Annual Target",
      icon: <AnnualTargetWhiteIcon />,
      value: `$${currencyFormatter(totalAnnualTarget)}`,
      loadingKey: "annualTarget"
    },
    {
      title: "YTD Commission",
      icon: <PercentYtdIcon />,
      value: `${ytdCommission}`,
      loadingKey: "commission"
    }
  ];